import * as Yup from 'yup';

export const lugarValidationSchema = Yup.object().shape({
  id: Yup.number()
    .required('El ID es obligatorio')
    .typeError('El ID debe ser un número válido'),

  descripcion: Yup.string()
    .required('La descripción es obligatoria')
    .typeError('La descripción debe ser una cadena de texto válida'),
});

export const validateLugarForm = async (formData) => {
  try {
    await lugarValidationSchema.validate(formData, { abortEarly: false });
    return {};
  } catch (error) {
    const errors = {};
    if (error.inner) {
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
    }
    return errors;
  }
};
